import { Injectable } from '@angular/core';
import { HttpClient, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SatisfactionService {

  path = environment.apiUrl

  constructor(private http: HttpClient) { }

  AddSatisfaction(body:any): Observable<any> {
    let URL = this.path + 'api/Users/AddSatisfaction';
    
    return this.http.post(URL, body);
  }

  Get_Satisfaction(): Observable<any> {
    let URL = this.path + 'api/Users/GetSatisfaction';
 
    return this.http.get(URL);
  }

  Get_Satisfaction_Comment(): Observable<any> {
    let URL = this.path + 'api/Users/GetSatisfaction_Comment';
 
    return this.http.get(URL);
  }

  Get_ip_address(): Observable<any> {
 
    return this.http.get('https://api.ipify.org?format=json');
  }

}
